import { Box, Button } from "@mui/material";
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState, Fragment } from "react";
import { DeleteOutline } from "@mui/icons-material";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { Product } from "../../../../api/models/schema";

interface RowItem {
  productId: number;
  editProductId: number;
  name: string;
  description: string;
  height: number;
  length: number;
  weight: number;
  thickness: number;
  min2Ft: number;
  max2Ft: number;
  trayType: string;
}

export interface ProductGridProps {
  products: Product[];
  selectProduct: (productId: number) => void;
  deleteProduct: (productId: number) => void;
}

export function ProductGrid(props: ProductGridProps) {
  const [productRows, setProductRows] = useState<RowItem[]>([]);

  const columns: GridColDef[] = [
    { field: "name", headerName: "Name", width: 130 },
    { field: "description", headerName: "Description", width: 310 },
    {
      field: "height",
      headerName: "Height",
      width: 125
    },
    { field: "weight", headerName: "Weight", width: 100 },
    { field: "length", headerName: "Length", width: 100 },
    {
      field: "thickness",
      headerName: "Thickness",
      width: 100,
      sortable: false,
    },
    {
      field: "min2Ft",
      headerName: "Min2Ft",
      width: 100,
      sortable: false,
    },
    {
      field: "max2Ft",
      headerName: "Max2Ft",
      width: 100,
      sortable: false,
    },
    {
      field: "trayType",
      headerName: "Tray Type",
      width: 120,
      sortable: false,
    },
    {
      field: "editProductId",
      headerName: "",
      width: 80,
      renderCell: editButton,
    },
    {
      field: "productId",
      headerName: "",
      width: 80,
      renderCell: deleteButton,
    }
  ];

  const handleClickOpenEdit = (productId: number) => {
    props.selectProduct(productId);
  };

  const handleClickOpenDelete = (productId: number) => {
    props.deleteProduct(productId);
  };

  function deleteButton(params: GridCellParams) {
    const productId = params.value;
    return (
      <Fragment>
        <Button onClick={() => handleClickOpenDelete(productId)}>
          <DeleteOutline color="error" />
        </Button>
      </Fragment>
    );
  }

  function editButton(params: GridCellParams) {
    const productId = params.value;
    return (
      <Fragment>
        <Button onClick={() => handleClickOpenEdit(productId)}>
          <ModeEditIcon color="primary" />
        </Button>
       
      </Fragment>
    );
  }

  useEffect(() => {
    const mapRows: RowItem[] = props.products.map((row) => ({
      productId: row.productId,
      editProductId: row.productId,
      name: row.name,
      description: row.description,
      height: row.height,
      weight: row.weight,
      length: row.length,
      thickness: row.thickness,
      min2Ft: row.min2Ft,
      max2Ft: row.max2Ft,
      trayType: row.trayType ?? '',
    }));

    setProductRows(mapRows);
  }, [props]);

  return (
    <Box>
      <DataGrid
        autoHeight
        rows={productRows}
        density="compact"
        disableSelectionOnClick
        rowsPerPageOptions={[20]}
        pageSize={20}
        columns={columns}
        style={{ backgroundColor: "#FFFFFF" }}
        getRowId={(row) => row.productId}
      />
    </Box>
  );
}
